module.exports = __webpack_public_path__ + "a0d1908dd95250d1b2d46aa2a290268d.png";